import { render, staticRenderFns } from "./meritManagement.vue?vue&type=template&id=3c1c580d&scoped=true&"
import script from "./meritManagement.vue?vue&type=script&lang=js&"
export * from "./meritManagement.vue?vue&type=script&lang=js&"
import style0 from "./meritManagement.vue?vue&type=style&index=0&id=3c1c580d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c580d",
  null
  
)

export default component.exports